import * as React from 'react';
const SvgHome = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M5.75 16.583a1.28 1.28 0 0 1-.943-.393 1.3 1.3 0 0 1-.39-.947V8.378q0-.313.139-.593.14-.28.4-.487L9.2 4.108q.375-.26.799-.26t.8.26l4.244 3.19q.262.207.401.487.14.28.14.593v6.865q0 .553-.394.947a1.3 1.3 0 0 1-.947.393zm.007-1.083h8.487a.25.25 0 0 0 .184-.072.25.25 0 0 0 .072-.185V8.378a.24.24 0 0 0-.028-.116.3.3 0 0 0-.076-.092l-4.244-3.183A.22.22 0 0 0 10 4.931a.22.22 0 0 0-.152.056L5.604 8.17a.3.3 0 0 0-.076.092.24.24 0 0 0-.028.116v6.865a.25.25 0 0 0 .072.185.25.25 0 0 0 .185.072'
            />
        </g>
    </svg>
);
export default SvgHome;
